<app-layout-container [navbarItems]="navbar()" [tabbar]="tabbar()" [useCard]="false">
  @if (!hideBuildingDetailsHeader()) {
    @if (showInlineLabelImprovement) {
      <cfp-label-improvement-inline
        [building]="building()"
        (labelGroupChange)="setLabelGroup($event)"
        (labelGroupsChange)="setLabelGroups($event)"
        (currentLabelChange)="setCurrentLabel($event)"
      >
        <cfp-building-details-header [building]="building()" />
      </cfp-label-improvement-inline>
    } @else {
      <cfp-building-details-header [building]="building()" [showDownloadReportButton]="showDownloadReportButton">
        <ng-content select="[building-header-dropdown-options-top]" building-header-dropdown-options-top />
        <cfp-page-section-building
          building-header
          [portfolioId]="portfolioId()"
          [buildingId]="buildingId()"
          [section]="'BUILDING_HEADER'"
        />
      </cfp-building-details-header>
    }
  }

  @let buildingLayoutDataValue = buildingLayoutData();
  @if (buildingLayoutDataValue) {
    <router-outlet [routerOutletData]="buildingLayoutDataValue" />
  }
</app-layout-container>
